import { Component, inject, signal } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { RouterOutlet, RouterLink, RouterLinkActive, Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { AuthService } from '../../core/services/auth.service';
import { RoleFormatPipe } from '../pipes/role-format.pipe';
import { TaskNotificationsComponent } from './task-notifications.component';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterLink, RouterLinkActive, MatIconModule, RoleFormatPipe, TaskNotificationsComponent],
  animations: [
    trigger('expandCollapse', [
      state('collapsed', style({ height: '0', opacity: 0, visibility: 'hidden', overflow: 'hidden' })),
      state('expanded', style({ height: '*', opacity: 1, visibility: 'visible' })),
      transition('expanded <=> collapsed', [
        animate('300ms cubic-bezier(0.4, 0, 0.2, 1)')
      ]),
    ]),
  ],
  template: `
    <div class="app-container" [class.sidebar-open]="isSidebarOpen">
      <aside class="app-sidebar" [class.is-collapsed]="!isSidebarOpen">
        <div class="sidebar-brand">
          <img src="/logo.png" alt="Logo REP" class="brand-logo-img">
          <div class="brand-text">REP</div>
        </div>

        <nav class="sidebar-nav">
          <div class="nav-section-header" (click)="toggleSection('principal')">
            <span>PRINCIPAL</span>
            <mat-icon class="chevron-icon" [class.rotated]="this.sections()['principal']">chevron_right</mat-icon>
          </div>
          <div class="nav-section-content" [@expandCollapse]="this.sections()['principal'] ? 'expanded' : 'collapsed'">
            <a routerLink="/dashboard" routerLinkActive="active" class="nav-item" (click)="onNavItemClick()">
              <mat-icon class="nav-icon" aria-hidden="true">dashboard</mat-icon>
              Tableau de bord
            </a>
          </div>

          <div *ngIf="authService.currentUser()?.role === 'ROLE_ADMIN' || authService.currentUser()?.role === 'ROLE_RESP_AFFAIRE'" class="nav-section-header" (click)="toggleSection('clients')">
            <span>GESTION DES CLIENTS</span>
            <mat-icon class="chevron-icon" [class.rotated]="this.sections()['clients']">chevron_right</mat-icon>
          </div>
          <div *ngIf="authService.currentUser()?.role === 'ROLE_ADMIN' || authService.currentUser()?.role === 'ROLE_RESP_AFFAIRE'" class="nav-section-content" [@expandCollapse]="this.sections()['clients'] ? 'expanded' : 'collapsed'">
            <div class="nav-group">
              <a routerLink="/clients" routerLinkActive="active" class="nav-item" (click)="onNavItemClick()">
                <mat-icon class="nav-icon" aria-hidden="true">business</mat-icon>
                Clients
              </a>
            </div>
            <div class="nav-group">
              <a routerLink="/contacts" routerLinkActive="active" class="nav-item" (click)="onNavItemClick()">
                <mat-icon class="nav-icon" aria-hidden="true">contacts</mat-icon>
                Contacts
              </a>
            </div>
          </div>

          <div *ngIf="authService.currentUser()?.role === 'ROLE_ADMIN' || authService.currentUser()?.role === 'ROLE_RESP_AFFAIRE'" class="nav-section-header" (click)="toggleSection('affaires')">
            <span>GESTION DES AFFAIRES</span>
            <mat-icon class="chevron-icon" [class.rotated]="this.sections()['affaires']">chevron_right</mat-icon>
          </div>
          <div *ngIf="authService.currentUser()?.role === 'ROLE_ADMIN' || authService.currentUser()?.role === 'ROLE_RESP_AFFAIRE'" class="nav-section-content" [@expandCollapse]="this.sections()['affaires'] ? 'expanded' : 'collapsed'">
            <div class="nav-group">
              <a routerLink="/sous-traitants" routerLinkActive="active" class="nav-item" (click)="onNavItemClick()">
                <mat-icon class="nav-icon" aria-hidden="true">engineering</mat-icon>
                Sous-Traitants
              </a>
            </div>
            <div class="nav-group">
              <a routerLink="/affaires" routerLinkActive="active" class="nav-item" (click)="onNavItemClick()">
                <mat-icon class="nav-icon" aria-hidden="true">assignment</mat-icon>
                Affaires
              </a>
            </div>
          </div>

          <div class="nav-section-header" (click)="toggleSection('projets')">
            <span>GESTION DES PROJETS</span>
            <mat-icon class="chevron-icon" [class.rotated]="this.sections()['projets']">chevron_right</mat-icon>
          </div>
          <div class="nav-section-content" [@expandCollapse]="this.sections()['projets'] ? 'expanded' : 'collapsed'">
            <div class="nav-group">
              <a routerLink="/projects" routerLinkActive="active" class="nav-item" (click)="onNavItemClick()">
                <mat-icon class="nav-icon" aria-hidden="true">folder</mat-icon>
                Projets
              </a>
              <a routerLink="/fats" routerLinkActive="active" class="nav-item" (click)="onNavItemClick()">
                <mat-icon class="nav-icon" aria-hidden="true">assignment</mat-icon>
                Menu FAT
              </a>
            </div>
          </div>

          <div *ngIf="authService.currentUser()?.role === 'ROLE_ADMIN'" class="nav-section-header" (click)="toggleSection('parametrage')">
            <span>PARAMÉTRAGE</span>
            <mat-icon class="chevron-icon" [class.rotated]="this.sections()['parametrage']">chevron_right</mat-icon>
          </div>
          <div *ngIf="authService.currentUser()?.role === 'ROLE_ADMIN'" class="nav-section-content" [@expandCollapse]="this.sections()['parametrage'] ? 'expanded' : 'collapsed'">
            <div class="nav-group">
              <a routerLink="/settings/doc-types" routerLinkActive="active" class="nav-item" (click)="onNavItemClick()">
                <mat-icon class="nav-icon" aria-hidden="true">description</mat-icon>
                Types de documents
              </a>
              <a routerLink="/settings/comptage-rules" routerLinkActive="active" class="nav-item" (click)="onNavItemClick()">
                <mat-icon class="nav-icon" aria-hidden="true">calculate</mat-icon>
                Règles de comptage
              </a>
              <a routerLink="/settings/statuses" routerLinkActive="active" class="nav-item" (click)="onNavItemClick()">
                <mat-icon class="nav-icon" aria-hidden="true">settings</mat-icon>
                Statuts
              </a>
              <a routerLink="/settings/teams" routerLinkActive="active" class="nav-item" (click)="onNavItemClick()">
                <mat-icon class="nav-icon" aria-hidden="true">groups</mat-icon>
                Équipes
              </a>
              <a routerLink="/settings/workflows" routerLinkActive="active" class="nav-item" (click)="onNavItemClick()">
                <mat-icon class="nav-icon" aria-hidden="true">tune</mat-icon>
                Workflows
              </a>
              <a routerLink="/settings/roles" routerLinkActive="active" class="nav-item" (click)="onNavItemClick()">
                <mat-icon class="nav-icon" aria-hidden="true">security</mat-icon>
                Rôles
              </a>
            </div>
            <div class="nav-group">
              <a routerLink="/users" routerLinkActive="active" class="nav-item" (click)="onNavItemClick()">
                <mat-icon class="nav-icon" aria-hidden="true">group</mat-icon>
                Utilisateurs
              </a>
              <a routerLink="/template-fat" routerLinkActive="active" class="nav-item" (click)="onNavItemClick()">
                <mat-icon class="nav-icon" aria-hidden="true">assignment</mat-icon>
                Template FAT
              </a>
            </div>
          </div>
        </nav>

        <div class="sidebar-footer">
          <div class="user-profile">
            <div class="user-avatar">
              {{ authService.currentUser()?.username?.charAt(0)?.toUpperCase() }}
            </div>
            <div class="user-details">
              <div class="user-name">{{ authService.currentUser()?.username }}</div>
              <div class="user-role">{{ authService.currentUser()?.role | roleFormat }}</div>
            </div>
          </div>
          <button (click)="onLogout()" class="logout-link">
            <mat-icon aria-hidden="true">logout</mat-icon>
            Déconnexion
          </button>
        </div>
      </aside>

      <main class="app-main">
        <header class="main-header">
          <button type="button" class="sidebar-toggle" (click)="toggleSidebar()" aria-label="Basculer la navigation">
            <mat-icon aria-hidden="true">{{ isSidebarOpen ? 'menu_open' : 'menu' }}</mat-icon>
          </button>
          <div class="header-title">
            {{ getPageTitle() }}
          </div>
        </header>
        <div class="main-content">
          <router-outlet></router-outlet>
        </div>
      </main>
    </div>
    <app-task-notifications></app-task-notifications>
  `,
  styles: [`
    .app-container {
      display: flex;
      height: 100%;
      height: 100dvh;
      overflow: hidden;
      width: 100%;
    }
    .app-sidebar {
      width: 260px;
      background-color: #0d47a1;
      color: white;
      display: flex;
      flex-direction: column;
      box-shadow: 4px 0 10px rgba(0,0,0,0.1);
      z-index: 10;
      overflow: hidden;
      min-height: 0;
      height: 100%;
      transition: width 0.2s ease, transform 0.2s ease;
    }
    .app-sidebar.is-collapsed {
      width: 0;
      transform: translateX(-100%);
    }
    .sidebar-brand {
      padding: 1.5rem 1.5rem;
      display: flex;
      align-items: center;
      gap: 0.75rem;
    }
    .brand-logo-img {
      width: 40px;
      height: 40px;
      object-fit: contain;
      background-color: white;
      border-radius: 6px;
      padding: 2px;
    }
    .brand-text {
      font-size: 1.25rem;
      font-weight: 700;
      letter-spacing: 0.5px;
    }
    .brand-text span {
      font-weight: 300;
      opacity: 0.8;
    }
    .sidebar-nav {
      flex: 1;
      padding: 0 1rem;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      min-height: 0;
      /* Scrollbar (Firefox) */
      scrollbar-width: thin;
      scrollbar-color: rgba(255,255,255,0.35) transparent;
    }
    /* Scrollbar (Chrome, Edge, Safari) */
    .sidebar-nav::-webkit-scrollbar {
      width: 8px;
    }
    .sidebar-nav::-webkit-scrollbar-track {
      background: transparent;
    }
    .sidebar-nav::-webkit-scrollbar-thumb {
      background-color: rgba(255,255,255,0.35);
      border-radius: 8px;
      border: 2px solid transparent;
    }
    .sidebar-nav:hover::-webkit-scrollbar-thumb {
      background-color: rgba(255,255,255,0.5);
    }
    .nav-section-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.5rem;
      cursor: pointer;
      font-size: 0.7rem;
      font-weight: 700;
      color: rgba(255,255,255,0.5);
      margin: 1.5rem 0 0.5rem;
      letter-spacing: 1px;
      text-transform: uppercase;
      transition: color 0.2s;
      border-radius: 4px;
    }
    .nav-section-header:hover {
      color: white;
      background-color: rgba(255,255,255,0.05);
    }
    .chevron-icon {
      transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }
    .chevron-icon.rotated {
      transform: rotate(90deg);
    }
    .nav-section-content {
      overflow: hidden;
    }
    .nav-section-header mat-icon {
      font-size: 1.1rem;
      width: 1.1rem;
      height: 1.1rem;
    }
    .nav-item {
      display: flex;
      align-items: center;
      padding: 0.75rem 1rem;
      color: rgba(255,255,255,0.8);
      text-decoration: none;
      border-radius: 8px;
      margin-bottom: 0.25rem;
      transition: all 0.2s;
      font-size: 0.95rem;
    }
    .nav-item:hover {
      background-color: rgba(255,255,255,0.08);
      color: white;
    }
    .nav-item.active {
      background-color: rgba(255,255,255,0.14);
      color: #fff;
      font-weight: 600;
    }
    .nav-icon {
      margin-right: 0.75rem;
      font-size: 1.1rem;
    }
    .sidebar-footer {
      padding: 1rem 1.5rem;
      border-top: 1px solid rgba(255,255,255,0.1);
      background-color: rgba(0,0,0,0.1);
      flex-shrink: 0;
      padding-bottom: calc(1rem + env(safe-area-inset-bottom, 0px));
    }
    .user-profile {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      margin-bottom: 0.75rem;
    }
    .user-avatar {
      width: 40px;
      height: 40px;
      background-color: var(--secondary-color);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      color: white;
    }
    .user-name {
      font-size: 0.9rem;
      font-weight: 600;
    }
    .user-role {
      font-size: 0.75rem;
      opacity: 0.7;
    }
    .logout-link {
      width: 100%;
      background: transparent;
      border: 1px solid rgba(255,255,255,0.2);
      color: white;
      padding: 0.6rem;
      border-radius: 6px;
      cursor: pointer;
      font-size: 0.85rem;
      transition: all 0.2s;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;
    }
    .logout-link:hover {
      background-color: rgba(255,255,255,0.1);
      border-color: white;
    }
    @media (max-height: 700px) {
      .sidebar-brand { padding: 1rem; }
      .nav-section-header { margin-top: 0.75rem; }
      .user-profile { margin-bottom: 0.5rem; }
      .logout-link { padding: 0.4rem; font-size: 0.8rem; }
    }
    .app-main {
      flex: 1;
      display: flex;
      flex-direction: column;
      background-color: #f4f6f9;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
    }
    .main-header {
      min-height: 64px;
      background-color: white;
      display: flex;
      align-items: center;
      padding: 0.75rem 2rem;
      box-shadow: 0 1px 4px rgba(0,0,0,0.05);
      gap: 0.75rem;
      flex-shrink: 0;
      flex-wrap: wrap;
    }
    .sidebar-toggle {
      border: 1px solid var(--border-color);
      background: var(--surface-color);
      border-radius: 8px;
      width: 40px;
      height: 40px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: var(--text-secondary);
      transition: background-color 0.2s, border-color 0.2s, color 0.2s;
      flex-shrink: 0;
      min-width: 40px;
    }
    .sidebar-toggle:hover {
      background-color: var(--surface-muted);
      border-color: #d0d5dd;
      color: var(--text-primary);
    }
    .header-title {
      font-size: 1.2rem;
      font-weight: 600;
      color: #333;
    }
    .main-content {
      padding: 2rem;
    }
    @media (max-width: 900px) {
      .app-sidebar {
        position: fixed;
        left: 0;
        top: 0;
        height: 100%;
        height: 100dvh;
      }
      .app-sidebar.is-collapsed {
        transform: translateX(-100%);
      }
      .app-main {
        width: 100%;
      }
    }
    @media (max-width: 1024px) and (orientation: portrait) {
      .app-sidebar {
        width: 240px;
      }
      .app-container.sidebar-open .app-main {
        margin-left: 240px;
      }
      .main-header {
        padding: 0.5rem 1rem;
      }
      .sidebar-toggle {
        width: 36px;
        height: 36px;
        min-width: 36px;
      }
      .header-title {
        font-size: 1.05rem;
      }
      .main-content {
        padding: 1.25rem;
      }
    }
  `]
})
export class LayoutComponent {
  authService = inject(AuthService);
  router = inject(Router);
  isSidebarOpen = true;

  // État des sections repliables
  sections = signal<Record<string, boolean>>({
    principal: true,
    clients: true,
    affaires: true,
    projets: true,
    parametrage: false
  });

  toggleSection(section: string): void {
    this.sections.update(s => ({ ...s, [section]: !s[section] }));
  }

  getPageTitle(): string {
    const url = this.router.url;
    if (url.includes('dashboard')) return 'Tableau de bord';
    if (url.includes('projects')) {
      if (url.includes('edit')) return 'Modifier le Projet';
      return 'Gestion de projets';
    }
    if (url.includes('fats')) return 'Menu FAT';
    if (url.includes('clients')) return 'Gestion des clients';
    if (url.includes('contacts')) return 'Gestion des contacts';
    if (url.includes('sous-traitants')) return 'Gestion des sous-traitants';
    if (url.includes('affaires')) return 'Gestion des affaires';
    if (url.includes('users')) return 'Gestion des utilisateurs';
    if (url.includes('template-fat')) return 'Paramétrage Template FAT';
    if (url.includes('settings/comptage-rules')) return 'Gestion des règles de comptage';
    if (url.includes('settings/statuses')) return 'Gestion des statuts';
    if (url.includes('settings/workflows')) return 'Gestion des workflows';
    if (url.includes('settings/roles')) return 'Gestion des rôles';
    return 'REP';
  }

  onLogout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  onNavItemClick() {
    if (window.innerWidth <= 1024) {
      this.isSidebarOpen = false;
    }
  }
}

